<template>
    <Dialog 
          :header="formMode == 'edit' ? 'Chỉnh sửa cấp bậc': 'Tạo mới cấp bậc'"
          :visible.sync="displayDialog"
          :contentStyle="{overflow: 'visible'}"
          :style="{width: '40vw'}"
          :class="'popup-dialog'"
          :modal="true"
        >
        <div class="p-fluid">
            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <label>Cấp bậc<span class="error">*</span></label>
                </div>
                <div class="p-field">
                    <InputText maxlength="255" id="name" type="text" v-model="name" :placeholder="'Nhập cấp bậc'"/>
                    <small v-if="validationErrors && validationErrors['name']"
                        class="p-invalid" >{{validationErrors['name']}}</small>
                    <small v-if="name_exists"
                    class="p-invalid" >Cấp bậc bị trùng</small>
                </div>
            </div>
            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <label>Cấp trên</label>
                </div>
                <div class="p-field">
                    <Dropdown inputId="parent_id" v-model="parent_id" :options="optionsParent" optionLabel="label"  optionValue="value" placeholder="Chọn cấp trên"/>
                    <small v-if="validationErrors && validationErrors['parent_id']"
                        class="p-invalid" >{{validationErrors['parent_id']}}</small>
                </div>
            </div>
            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <label>Mô tả</label>
                </div>
                <div class="p-field">
                   <Textarea  id="description" rows="2"  v-model="description" :autoResize="true"/>
                </div>
            </div>
            <!-- <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <div class="p-field-checkbox">
                        <Checkbox v-model="is_management" :binary="true"/>
                        <label >Quản lý dữ liệu cấp dưới</label>
                    </div>
                </div>
            </div> -->

            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <div class="p-field-checkbox">
                        <Checkbox  v-model="status" :binary="true"/>
                        <label >Hiển thị sử dụng</label>
                    </div>
                </div>
            </div>
            
        </div>
        <template #footer>
            <Button :disabled="submitForm" class="p-button-success" :label="formMode == 'edit' ? 'Lưu' : 'Tạo'" @click="saveData" />
        </template>
      </Dialog>
</template>

<script>
import DataServices from '@/core/DataServices'

export default {
  props: {
    show: Boolean,
    mode: String,
    modelName: String,
    model: Object
  },
  data() {
    return {
        name: '',
        status: true,
        parent_id: 0,
        is_management: true,
        displayDialog: this.show,
        validationErrors: {},
        name_exists: false,
        optionsParent: [],
        submitForm: false,
        levelParentIndex: 0,
        description: ''
    }
  },
  async created() {
    this.formMode = this.mode;
    await this.listParents();
    if (this.formMode === 'edit' && this.model !== undefined && this.model !== null && Object.entries(this.model).length) {
      this.name = this.model.name;
      this.status = this.model.status > 0;
      this.parent_id = this.model.parent_id;
      this.is_management = this.model.is_management > 0;
      this.description = this.model.description;
    }
  },
  methods: {
    async listParents() {
        var whereKey = {
            status: {'_in': [0, 1] }
        }
      
        if (this.formMode === 'edit' && this.model !== undefined && this.model !== null && Object.entries(this.model).length) {
            whereKey = Object.assign(whereKey, {id: {'_neq': this.model.id}});
        }
        var variables = {
            where_key: whereKey
        }

        var data = await DataServices.getList('user_level', {"variables": JSON.stringify(variables), "fields": "id name level_parent_index"});
        var list = data[Object.keys(data)];
        if (list !== undefined && list !== null && Object.keys(list).length) {
            for (let index = 0; index < list.length; index++) {
                const item = list[index];
                this.optionsParent.push({label: item.name, value: item.id, item: item});
            }
        }
    },
    async validateData() {
        this.validationErrors = {};
        if (this.name === undefined || this.name == '') this.validationErrors['name'] = 'Nhập cấp bậc';
        this.name_exists = await this.checkName();
    },
    async checkName() {
        this.name = this.name.trim();
        if (this.name !== undefined && this.name !== "") {
            var where = { name: {'_ilike': this.name} }
            if (this.model !== undefined) where = Object.assign(where, {id: {'_neq': this.model.id}})
            var data = await DataServices.getList(this.modelName, {"fields": "id", "variables": JSON.stringify({where_key: where})});
            return data && data[Object.keys(data)].length > 0
        }
    },
    async saveData() {
        this.submitForm = true;
        await this.validateData();
        await this.changeParentIndex();
        if (!this.name_exists && Object.entries(this.validationErrors).length === 0) {
            // if (this.parent_id > 0) {
            //     var objParent = this.optionsParent.filter(a => a.value == this.parent_id);
            //     if (objParent && Object.keys(objParent).length) {
            //         this.levelParentIndex = Number( objParent[0].item.level_parent_index) + 1;
            //     }
            // } else this.levelParentIndex = 0;
            var params = {
                'name': this.name,
                'status': this.status ? 1 : 0,
                // 'is_management': this.is_management,
                'description': this.description,
                'parent_id': this.parent_id,
                'level_parent_index': this.levelParentIndex
            }
           
            
            if (this.formMode === 'add') {
                params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
                params = Object.assign(params, { 'created_at': this.$myConstants.currentDate() })
                await DataServices.insertData(this.modelName, {"variables": JSON.stringify({objects: params})});
                this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Tạo mới thành công', life: 3000 })
                this.displayDialog = false;
                this.$emit('refresh');
                
            } else {
                params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() });
                await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.model.id }}})});

                this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
                this.displayDialog = false;

                this.$emit('refresh');
            }
        } else this.submitForm = false;
    },
    async getLevelIndex(whereKey) {
        var variables = {
            where_key: whereKey,
            orderBy: {
                'level_parent_index': 'desc'
            },
            limit: 1
        }
        var data = await DataServices.getList(this.modelName, {"fields": "id parent_id level_parent_index", "variables": JSON.stringify(variables)});
        if (data[Object.keys(data)].length) {
            data = data[Object.keys(data)][0];
            return data;
        }
        return null;
    },
    async changeParentIndex() {
        // nếu chọn không có cấp trên
        if (this.parent_id == 0) {
            // nếu là thêm thì tạo mới
            if (this.model == null || this.model == undefined || (this.model != undefined && this.model != null && Object.keys(this.model).length) == 0) {
                var whereKey = {
                    parent_id: {'_is_null': true}
                }
                var data = await this.getLevelIndex(whereKey);
                if (data != null) {
                    // tăng 1 cấp cao nhất
                    this.levelParentIndex = Number(data.level_parent_index) + 1;
                }
            }
        } else {
            // lấy index của cấp cha
            var whereParent = {
                id: {'_eq': this.parent_id}
            }
            var dataParent = await this.getLevelIndex(whereParent);
            if (dataParent != null) {
                var parentIndex = Number(dataParent.level_parent_index);
                var whereParentList = {
                    parent_id: {'_eq': this.parent_id}
                }
                var dataParentList = await this.getLevelIndex(whereParentList);
                if (dataParentList != null) {
                    if (dataParentList.level_parent_index < 10) this.levelParentIndex = (parentIndex  * 100) + 10;
                    else this.levelParentIndex = dataParentList.level_parent_index + 1;
                } else {
                    this.levelParentIndex = (parentIndex  * 100) + 10;
                }
            }
        }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>